import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const CTA = () => {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yBg = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section ref={ref} id="contact" className="relative py-24 md:py-40 lg:py-56 overflow-hidden bg-brand-dark" data-id="element-38">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-39">
        <motion.div style={{
        y: yBg
      }} className="w-full h-[120%] -top-[10%] absolute" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/izZHwqrQkC9cpfBcRpymy9/IMG_2742-PROOF-THOMAS-MASOTTI.jpg" alt="Traitement de détatouage laser dans le dos chez Dispel Your Tattoo" className="w-full h-full object-cover object-center opacity-25 grayscale" loading="lazy" data-id="element-41" />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/90 to-brand-dark/70" data-id="element-42"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-43">
        <ScrollReveal blur scale duration={1.2} data-id="element-44">
          <h2 className="text-4xl md:text-4xl lg:text-6xl xl:text-7xl font-medium text-brand-light mb-8 md:mb-12 tracking-tight leading-[1.2] text-balance" data-id="element-45">
            Réservez Votre Consultation de Détatouage à Martigny
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} blur data-id="element-46">
          <p className="text-lg md:text-xl lg:text-2xl text-brand-gray font-light mb-12 md:mb-20 max-w-3xl mx-auto leading-relaxed" data-id="element-47">
            Je me ferai un plaisir de vous accueillir, d'évaluer votre projet et
            de répondre à toutes vos questions avec professionnalisme et
            transparence. Si vous recherchez un spécialiste exclusivement dédié
            au détatouage laser, Dispel Your Tattoo est votre adresse de
            confiance à Martigny.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} blur data-id="element-48">
          <motion.a href="/contact#consultation-form" whileHover={{
          scale: 1.03,
          // Original broken value: '0 0 30px rgba(245,2<mp-planning>',
          boxShadow: '0 0 30px rgba(245,2,45,0.15)'
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="inline-block w-full sm:w-auto px-8 md:px-10 py-4 md:py-5 bg-brand-light text-brand-dark rounded-full font-bold uppercase tracking-wider hover:bg-white transition-colors duration-300 text-sm md:text-base" data-id="element-49">
            {/* TA.tsx button uses `px-8 md:px-12 py-4 md:py-6`. This is the text-brand-dark */}
            Réserver une consultation
          </motion.a>
        </ScrollReveal>
      </div>
    </section>;
};